module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(_vm.disabled) ? _c('div', {
    staticClass: "html-remarks"
  }, [(_vm.formData) ? _c('p', {
    style: ('height: ' + _vm.height / 2 + 'px;'),
    domProps: {
      "innerHTML": _vm._s(_vm.formData)
    }
  }) : _vm._e()]) : _c('div', [_c('quill-editor', {
    style: ('height: ' + _vm.height + 'px; width: ' + _vm.width + '; overflow: auto;'),
    attrs: {
      "options": _vm.editorOptions
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61462a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/HtmlInput.vue
// module id = 1522
// module chunks = 0